/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommButtonViewProps } from './ecomm-button';

export default (props: IEcommButtonViewProps) => {
    const { config } = props;

    const url =
        config.anchorTargetID !== undefined && config.anchorTargetID !== ''
            ? `#${config.anchorTargetID}`
            : config.link?.linkUrl.destinationUrl;

    return (
        <div className='ecomm-button'>
            <a href={url}>{config.link?.linkText}</a>
        </div>
    );
};
